import { Autocomplete, Grid, TextField } from '@mui/material';
import { getCompanies } from 'api';
import { DialogHelp } from 'components';
import React, { useEffect, useState } from 'react';

const ClientAccessPoint = ({
	openDialog,
	onCloseDialog,
	setPending,
	setCustId,
	custId,
}) => {
	const [listOfCompanies, setListOfCompanies] = useState([]);
	const [selectedCompany, setSelectedCompany] = useState(null);

	useEffect(() => {
		const getAllCompanies = async () => {
			setPending(true);
			const result = await getCompanies();
			setListOfCompanies(result);
			setPending(false);
		};
		if (listOfCompanies.length === 0) {
			getAllCompanies();
		}
	}, [listOfCompanies]);

	// Set the default value based on custId whenever the dialog is opened
	useEffect(() => {
		if (openDialog && listOfCompanies.length > 0) {
			const defaultCompany = listOfCompanies.find(
				(company) => Number(company.Id) === custId,
			);
			setSelectedCompany(defaultCompany);
		}
	}, [openDialog, custId, listOfCompanies]);

	return (
		<DialogHelp
			open={openDialog}
			onClose={onCloseDialog}
			title={`Select Customer`}
			onCloseButtonText={'Cancel'}
			content={
				<>
					<Autocomplete
						disablePortal
						id="combo-box-demo"
						options={listOfCompanies}
						getOptionLabel={(option) => option.Name}
						renderOption={(props, option) => (
							<li {...props} key={option.Id}>
								{option.Name}
							</li>
						)}
						sx={{ width: 300, height: 300 }}
						value={selectedCompany} // Set the value prop
						onChange={(event, newValue) => {
							if (newValue) {
								setCustId(Number(newValue.Id));
								onCloseDialog();
							}
						}}
						renderInput={(params) => (
							<TextField {...params} label="Customer" />
						)}
					/>
				</>
			}
		/>
	);
};

export default ClientAccessPoint;
